import { css } from '@emotion/react';

export const filterModalStyles = css`
  .filter-items {
    max-height: 22rem !important;
  }
`;
